import './SchoolClothesPage.scss';

import {DeleteFilled, EditFilled, MinusOutlined, PlusOutlined} from '@ant-design/icons';
import {Button, Col, Row} from 'antd';
import {getFormattedPrice} from 'helpers/Formatting';
import {getPurchaseStatus} from 'helpers/PurchaseStatus';
import React, {useState} from 'react';

import {SinifUrunu} from '../../../gql/GeneratedGraphqlTypes';
import {SecilenUrun} from '../../../pages/class-products/ClassProductsPage';
import GroupProductsModal from '../../class-group-product-modal/GroupProductsModal';
import GroupProductsModalTekstil from '../../class-group-product-modal/GroupProductsModalTekstil';
import PurchaseTag from '../../purchase-tag/PurchaseTag';
import ProductCardCarousel from './ProductCardCarousel';

export const SchoolClothesPage: React.FC<{
    grupluUrunler?: any;
    selectedProducts: SecilenUrun[];
    setSelectedProducts: React.Dispatch<React.SetStateAction<SecilenUrun[]>>;
    cokluSatis?: boolean;
}> = ({
          grupluUrunler,
          selectedProducts,
          setSelectedProducts,
          cokluSatis = false,
      }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalProducts, setModalProducts] = useState<SinifUrunu[]>([]);
    const [selectedGroupId, setSelectedGroupId] = useState<number>(0);

    const flatUrunler: SinifUrunu[] = (grupluUrunler ?? []).flat();

    // Ders bazında gruplandır (her ders için ayrı kart grubu)
    const isNested = Array.isArray((grupluUrunler ?? [])[0]);
    const dersGroups: SinifUrunu[][] = isNested
        ? (grupluUrunler as SinifUrunu[][])
        : flatUrunler.length > 0 ? [flatUrunler] : [];

    const showModal = (product: SinifUrunu) => {
        const grupId = product.urun?.grup?.id ?? 0;
        setSelectedGroupId(grupId);
        setIsModalOpen(true);
        const seen = new Set<string>()
        setModalProducts(
            flatUrunler
                .filter((item) => item.urun?.grup?.id === grupId)
                .filter((item) => {
                    const stkId = item.urun?.bilgiler?.find((b: any) => b?.isim === 'StkID')?.deger
                    const key = stkId ?? String(item.urun_id)
                    if (seen.has(key)) return false
                    seen.add(key)
                    return true
                })
                .sort((a, b) => {
                    const siraA = typeof a.urun?.sira === 'number' ? a.urun.sira : Number.MAX_SAFE_INTEGER;
                    const siraB = typeof b.urun?.sira === 'number' ? b.urun.sira : Number.MAX_SAFE_INTEGER;
                    return siraA - siraB;
                })
        );
    };

    const updateAdet = (urunId: number, delta: number) => {
        setSelectedProducts((prev) => {
            const current = prev.find((p) => p.urunId === urunId);
            if (!current) return prev;
            const nextAdet = current.adet + delta;
            if (nextAdet < 1) return prev.filter((p) => p.urunId !== urunId);
            return prev.map((p) => p.urunId === urunId ? {...p, adet: nextAdet} : p);
        });
    };

    const renderProductCards = (products: SinifUrunu[]) => {
        let gruplarArr: SinifUrunu[] = [];
        products.forEach((element: SinifUrunu) => {
            const exists = gruplarArr.some(
                (item: SinifUrunu) => item.urun?.grup?.id === element?.urun?.grup?.id
            );
            if (!exists) gruplarArr.push(element);
        });
        gruplarArr = gruplarArr.sort((a, b) => {
            const siraA = a.urun?.grup?.sira ?? Number.MAX_SAFE_INTEGER;
            const siraB = b.urun?.grup?.sira ?? Number.MAX_SAFE_INTEGER;
            return siraA - siraB;
        });

        return gruplarArr.map((product, index) => {
            const key = `${product.urun?.grup?.id}-${index}`;
            const existing = selectedProducts.find((p) => p.grupId === product.urun?.grup?.id);
            const resimler: string[] = (product.urun?.grup?.resimler ?? []).filter(Boolean) as string[];
            const satinAlmaDurumu = getPurchaseStatus(
                products.filter((p) => p.urun?.grup?.id === product.urun?.grup?.id)
            );
            return (
                <Col key={key} xs={24} sm={12} md={8} style={{display: 'flex'}}>
                    <div className="product-card" style={{width: '100%'}}>
                        <div className="product-card-content">
                            <ProductCardCarousel resimler={resimler} alt={product.urun?.isim || ''} />
                            <div className="product-info">
                                <span>{product.urun?.grup?.isim || product.urun?.isim}</span>
                                <PurchaseTag status={satinAlmaDurumu} />
                                {product.urun?.kisa_aciklama && (
                                    <span style={{color: 'red', fontSize: '13px', fontWeight: 400}}>
                                        {product.urun.kisa_aciklama}
                                    </span>
                                )}
                                <span>
                                    {product.indirimli_birim_fiyat ? (
                                        <>
                                            <span className="card-indirimli-fiyat">
                                                {getFormattedPrice(product.indirimli_birim_fiyat)} TL
                                            </span>
                                            {product.indirimsiz_birim_fiyat &&
                                            parseFloat(product.indirimsiz_birim_fiyat) > parseFloat(product.indirimli_birim_fiyat) ? (
                                                <span className="card-indirimsiz-fiyat">
                                                    {getFormattedPrice(product.indirimsiz_birim_fiyat)} TL
                                                </span>
                                            ) : null}
                                        </>
                                    ) : (
                                        'Fiyat Yok'
                                    )}
                                </span>
                            </div>
                        </div>
                        <div className="product-card-footer">
                            {existing ? (
                                <>
                                    <div onClick={() => showModal(product)} className="change-size-div">
                                        <h3>{existing.secilenBeden}</h3>
                                        <span><EditFilled/> Değiştir</span>
                                    </div>
                                    <div className="school-clothes-quantity-div">
                                        <Button
                                            icon={existing.adet === 1 ? <DeleteFilled/> : <MinusOutlined/>}
                                            onClick={() => updateAdet(existing.urunId, -1)}
                                        />
                                        <span className="quantity">{existing.adet}</span>
                                        <Button
                                            icon={<PlusOutlined/>}
                                            onClick={() => updateAdet(existing.urunId, 1)}
                                        />
                                    </div>
                                </>
                            ) : (
                                <Button onClick={() => showModal(product)} className="choose-size-button">
                                    Beden Seç
                                </Button>
                            )}
                        </div>
                    </div>
                </Col>
            );
        });
    };

    return (
        <div className="school-clothes-page">
            {dersGroups.map((dersUrunleri, dersIndex) => {
                const dersIsim = dersUrunleri[0]?.ders?.isim;
                const dersRenk = dersUrunleri[0]?.ders?.renk;
                return (
                    <div key={dersIndex} className="ders-group">
                        {dersGroups.length > 1 && dersIsim && (
                            <div
                                className="ders-group-header"
                                style={{ '--ders-renk': dersRenk || 'var(--color-primary)' } as React.CSSProperties}
                            >
                                {dersIsim}
                            </div>
                        )}
                        <Row gutter={[16, 16]}>
                            {renderProductCards(dersUrunleri)}
                        </Row>
                    </div>
                );
            })}

            {cokluSatis ? (
                <GroupProductsModalTekstil
                    modelVisible={isModalOpen}
                    setModalVisible={setIsModalOpen}
                    selectedProducts={selectedProducts}
                    setSelectedProducts={setSelectedProducts}
                    products={modalProducts}
                    cokluSatis={true}
                    selectedGroupId={selectedGroupId}
                />
            ) : (
                <GroupProductsModal
                    modelVisible={isModalOpen}
                    setModalVisible={setIsModalOpen}
                    selectedProducts={selectedProducts}
                    setSelectedProducts={setSelectedProducts}
                    products={modalProducts}
                    cokluSatis={false}
                />
            )}
        </div>
    );
};
